export const COUNTRIES = [
  {
    slug: "KGZ",
    label: "Кыргызстан",
    icon: require("../assets/kgz.svg"),
    currency: "KGS",
    services: [
      {
        id: "office",
        icon: require("../assets/rc-office.svg"),
        name: "RC OFFICE",
        link: process.env.VUE_APP_RC_OFFICE_LOCAL_KG,
      },
    ],
  },
  // {
  //   slug: "UZB",
  //   label: "Узбекистан",
  //   icon: require("../assets/uzb.svg"),
  //   currency: "UZS",
  //   services: [
  //     {
  //       id: "office",
  //       icon: require("../assets/rc-office.svg"),
  //       name: "RC OFFICE",
  //       link: process.env.VUE_APP_RC_OFFICE_LOCAL_UZ,
  //     },
  //   ],
  // },
  // {
  //   slug: "tj",
  //   label: "Таджикистан",
  //   icon: require("../assets/tj.svg"),
  // },
  // {
  //   slug: "ae",
  //   label: "ОАЭ",
  //   icon: require("../assets/ae.svg"),
  // },
  // {
  //   slug: "GHA",
  //   label: "Гана",
  //   icon: require("../assets/gh.svg"),
  // },
];
